import registrationStore from "./registrationStore";
export default registrationStore;



// WEBPACK FOOTER //
// ./src/stores/registrationStore/index.js